// Zoeken in de pictogramkiezer (IconPicker): los bestand zodat het zonder DOM te testen is.

/** Kleine letters, accenten weg: "pinguin" vindt "Pinguïn". */
export function normalizePictoQuery(s: string): string {
  return s.toLowerCase().normalize('NFD').replace(/\p{M}/gu, '');
}

export interface PictoSearchLabels {
  /** Namen per pictogram-id (i18n `design.picto`). */
  picto: Readonly<Record<string, string>>;
  /** Extra zoekwoorden per pictogram-id, spatiegescheiden (i18n `design.pictoKeywords`). */
  keywords?: Readonly<Record<string, string>> | undefined;
}

/** Past pictogram `id` bij zoekterm `q` (al genormaliseerd)? Zoekt in id, naam en zoekwoorden. */
export function matchesPicto(id: string, q: string, labels: PictoSearchLabels): boolean {
  if (id.includes(q) || normalizePictoQuery(labels.picto[id] ?? id).includes(q)) return true;
  const extra = labels.keywords?.[id];
  // "quran_lesson" (woordgroep voor het titelvoorstel) is hier gewoon "quran lesson".
  return extra ? normalizePictoQuery(extra.replace(/_/g, ' ')).includes(q) : false;
}
